import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { A11yModule } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkTableModule } from '@angular/cdk/table';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRadioModule } from '@angular/material/radio';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedModule } from '../shared/shared.module';
import { AmenaRoutingModule } from './amena-routing.module';
import { AmenaIndexComponent } from './components/amena-index/amena-index.component';
import { AmenaComponent } from './components/amena/amena.component';
import { CoberturaMigrationComponent } from './components/cobertura-migration/cobertura-migration.component';
import { CoberturaComponent } from './components/cobertura/cobertura.component';
import { ConfirmationPreloaderComponent } from './components/confirmation-preloader/confirmation-preloader.component';
import { ClienteComponent } from './components/confirmation/cliente/cliente.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { PostActivationComponent } from './components/confirmation/post-activation/post-activation.component';
import { PreActivationComponent } from './components/confirmation/pre-activation/pre-activation.component';
import { ResumenComponent } from './components/confirmation/resumen/resumen.component';
import { CustomerComponent } from './components/customer/customer.component';
import { LandlineConfigurationComponent } from './components/landline-configuration/landline-configuration.component';
import { ListadoActivacionesComponent } from './components/listado-activaciones/listado-activaciones.component';
import { MobilePackComponent } from './components/mobile-pack/mobile-pack.component';
import { ModalSaveComponent } from './components/modal-save/modal-save.component';
import { NormalizaDireccionComponent } from './components/normaliza-direccion/normaliza-direccion.component';
import { OrderDetailComponent } from './components/order-detail/order-detail.component';
import { OrderDocumentComponent } from './components/order-document/order-document.component';
import { RateDetailComponent } from './components/rate-detail/rate-detail.component';
import { RateComponent } from './components/rate/rate.component';
import { ShopingCartComponent } from './components/shoping-cart/shoping-cart.component';
import { SubheaderComponent } from './components/subheader/subheader.component';
import { TerminalDeliveryComponent } from './components/terminal-delivery/terminal-delivery.component';
import { TerminalComponent } from './components/terminal/terminal.component';
import { UserActivacionTiendaComponent } from './components/user-activacion-tienda/user-activacion-tienda.component';
import { UserBankingDataComponent } from './components/user-banking-data/user-banking-data.component';
import { UserDataFormComponent } from './components/user-data-form/user-data-form.component';
import { UserDataComponent } from './components/user-data/user-data.component';
import { UserPortabilityDataComponent } from './components/user-portability-data/user-portability-data.component';
import { GuardDraftGuard } from './services/guard-draft.guard';


export const MY_FORMATS = {
    parse: {dateInput: 'DD/MM/YYYY'},
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    }
};

@NgModule({ declarations: [
        SubheaderComponent,
        AmenaComponent,
        UserDataComponent,
        TerminalComponent,
        RateComponent,
        RateDetailComponent,
        TerminalDeliveryComponent,
        MobilePackComponent,
        ShopingCartComponent,
        NormalizaDireccionComponent,
        CoberturaComponent,
        UserDataFormComponent,
        UserBankingDataComponent,
        UserPortabilityDataComponent,
        ConfirmationComponent,
        PreActivationComponent,
        PostActivationComponent,
        ListadoActivacionesComponent,
        LandlineConfigurationComponent,
        ClienteComponent,
        ResumenComponent,
        UserActivacionTiendaComponent,
        ModalSaveComponent,
        ConfirmationPreloaderComponent,
        OrderDetailComponent,
        OrderDocumentComponent,
        AmenaIndexComponent,
        CustomerComponent,
        CoberturaMigrationComponent
    ],
    exports: [
        UserDataFormComponent,
        SubheaderComponent,
        ShopingCartComponent,
        RateDetailComponent,
        RateComponent
    ], imports: [CommonModule,
        AmenaRoutingModule,
        MatButtonModule,
        MatRadioModule,
        A11yModule,
        CdkTableModule,
        DragDropModule,
        MatTabsModule,
        MatDialogModule,
        SharedModule], providers: [
        GuardDraftGuard
    ] })
export class AmenaModule { }
